<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
      ]"
      :is-print="isPrint"
    />

    <!-- 점검 대상 단위사업장 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="점검 대상 단위사업장"
      :tableData="[
        { id: 'data1', title: '단위사업장명', type: 'text', placeholder: '' },
        { id: 'data2', title: '담당자', type: 'text', placeholder: '' },
        { id: 'data3', title: '연락처', type: 'text', placeholder: '' },
        { id: 'data4', title: '비고', type: 'text', placeholder: '' },
      ]"
      :mobile="['data1', 'data2']"
      v-model="form.pobList"
      class="mt-28px"
    />

    <!-- 반기별 점검 -->
    <TableInspectMerge :is-print="isPrint" :is-readonly="board.readonly" title="반기별 점검" tableHeaderTitle="자가진단 항목" :isNote="false" v-model="form.inspectList" class="mt-28px" />

    <!-- 사진대지 -->
    <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList" section-title="사진대지" placeholder="00센터 신축현장 점검" :is-print="isPrint" :readonly="board.readonly" class="mt-28px" />

    <file-upload-module :readonly="board.readonly" v-if="!isPrint" class="mt-28px" v-model="form.fileList" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableCustom from "@/components/TableCustom";
import TableInspectMerge from "@/components/TableInspectMerge";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";

export default {
  components: {
    FieldSelectModule,
    TableCustom,
    TableInspectMerge,
    PhotoUploadGridModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        photoList: [],

        pobList: [],
        inspectList: [
          {
            content: "목표와 경영방침에 따른 설정",
            isChecked: "",
          },
          {
            content: "유해·위험요인을 확인하여 개선하는 업무절차에 따른 유해·위험요인 발굴 및 개선",
            isChecked: "",
          },
          {
            content: "안전보건관계자 등의 충실한 업무 수행",
            isChecked: "",
          },
          {
            content: "종사자 의견 수렴 절차에 따라 개선방안 마련 및 이행",
            isChecked: "",
          },
          {
            content: "중대산업재해가 발생하거나, 발생할 급박한 위험이 있을 경우를 대비한 매뉴얼에 따른 조치",
            isChecked: "",
          },
          {
            content: "도급·용역·위탁 시 수급인의 산업재해 예방 조치 능력에 관한 평가 기준, 안전보건을 위한 적정 관리비용 기준, 적정 기간 기준에 따른 도급·용역·위탁 관리",
            isChecked: "",
          },
          {
            content: "안전보건관계법령에 따른 의무 이행",
            isChecked: "",
          },
          {
            content: "유해·위험한 작업에 관한 안전·보건에 관한 교육 실시",
            isChecked: "",
          },
        ],
        fileList: [],
      },
    };
  },
};
</script>
